function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIllustrationWrapper } from '../../components/atoms/Illustration/withIllustrationWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IllustrationTlcAdvantage4 = function IllustrationTlcAdvantage4(props, ref) {
  return ___EmotionJSX("svg", _extends({
    width: "299",
    height: "246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), ___EmotionJSX("path", {
    opacity: ".3",
    d: "M6.62 77.922c-13.232 37.585-5.27 80.671 17.04 113.603 21.534 31.784 58.303 51.6 96.638 54.193 33.742 2.283 58.897-24.991 88.355-41.677 31.608-17.902 76.484-23.246 87.412-57.878 11.123-35.251-13.7-71.61-37.713-99.629-20.367-23.763-50.784-32.454-81.345-39.286C146.955.53 116.585-3.338 88.105 8.475 53.847 22.685 18.935 42.94 6.62 77.923z",
    fill: "url(#paint0_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M239.523 90.118h-112.86v84.43h112.86v-84.43z",
    fill: "url(#paint1_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M241.246 81.502H124.94v11.2h116.306v-11.2z",
    fill: "#A5A8AA"
  }), ___EmotionJSX("path", {
    d: "M175.77 102.179h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint2_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M190.416 102.179h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint3_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M205.062 102.179h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint4_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M220.569 102.179h-10.338v16.369h10.338v-16.369z",
    fill: "url(#paint5_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M235.216 102.179h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint6_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M175.77 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint7_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M190.416 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint8_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M205.062 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint9_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M220.569 123.718h-10.338v17.231h10.338v-17.231z",
    fill: "url(#paint10_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M235.216 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint11_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M209.37 150.425h-14.646v24.123h14.646v-24.123z",
    fill: "url(#paint12_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M193.862 150.425h-14.646v24.123h14.646v-24.123z",
    fill: "url(#paint13_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M211.093 147.84h-33.6v3.446h33.6v-3.446z",
    fill: "#A5A8AA"
  }), ___EmotionJSX("path", {
    d: "M146.478 102.179h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint14_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M161.124 102.179h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint15_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M146.478 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint16_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M161.124 123.718h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint17_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M132.693 67.718H54.294v106.83h78.399V67.718z",
    fill: "url(#paint18_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M133.555 59.103H52.571v11.2h80.984v-11.2z",
    fill: "#A5A8AA"
  }), ___EmotionJSX("path", {
    d: "M68.079 101.318h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint19_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M83.586 101.318H73.248v16.369h10.338v-16.369z",
    fill: "url(#paint20_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M98.232 101.318h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint21_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M112.878 101.318h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint22_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M127.524 101.318h-9.477v16.369h9.477v-16.369z",
    fill: "url(#paint23_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M68.079 122.856h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint24_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M83.586 122.856H73.248v17.231h10.338v-17.231z",
    fill: "url(#paint25_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M98.232 122.856h-9.477v17.231h9.477v-17.231z",
    fill: "url(#paint26_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M112.878 122.856h-9.476v17.231h9.476v-17.231z",
    fill: "url(#paint27_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M127.524 122.856h-9.476v17.231h9.476v-17.231z",
    fill: "url(#paint28_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M101.678 150.425h-17.23v24.123h17.23v-24.123z",
    fill: "url(#paint29_linear_250_6791)"
  }), ___EmotionJSX("path", {
    d: "M104.263 147.84h-22.4v3.446h22.4v-3.446z",
    fill: "#A5A8AA"
  }), ___EmotionJSX("path", {
    d: "M69.622 90.109a4.038 4.038 0 0 1-3.07-1.123 4.461 4.461 0 0 1-1.049-3.17 4.963 4.963 0 0 1 .315-1.829c.202-.508.503-.97.886-1.36.382-.37.837-.655 1.335-.839a4.773 4.773 0 0 1 1.678-.285c.32-.002.638.024.953.076.286.057.534.114.753.18.183.059.361.129.534.21.106.05.208.107.305.172l-.534 1.494a4.778 4.778 0 0 0-.886-.343 4.227 4.227 0 0 0-1.144-.142c-.289 0-.576.048-.848.142-.274.096-.521.252-.725.457-.225.23-.398.507-.505.81-.135.392-.2.804-.191 1.218 0 .36.042.717.124 1.067.076.308.215.596.41.847.192.247.445.44.734.561.345.151.72.223 1.096.21.241.016.484.016.725 0a4.334 4.334 0 0 0 1.01-.257l.343-.162.515 1.495a4.96 4.96 0 0 1-1.106.428 6.62 6.62 0 0 1-1.658.143zM79.279 88.456v1.662h-6.031v-8.616h2.034v6.964l3.997-.01zM80.14 81.502h1.723v8.616H80.14v-8.616zM89.837 90.118a37.187 37.187 0 0 0-1.679-2.925 29.488 29.488 0 0 0-1.93-2.716v5.64h-1.78v-8.615h1.475c.25.279.528.607.844.995.315.388.621.826.927 1.284.306.457.631.915.928 1.402.297.488.612.995.928 1.393v-5.074h1.79v8.616h-1.503zM93.063 81.502h2.585v8.616h-2.585v-8.616zM105.124 86.052a5.57 5.57 0 0 1-.229 1.633 4.222 4.222 0 0 1-.627 1.274c-.27.364-.608.672-.996.906a3.973 3.973 0 0 1-1.224.528c.039.16.134.302.269.398.162.117.344.205.537.259.246.066.495.116.747.149l.926.08-.398 1.423a10.106 10.106 0 0 1-1.653-.189 4.138 4.138 0 0 1-1.175-.438 2.26 2.26 0 0 1-.757-.667 3.013 3.013 0 0 1-.428-.916 4.54 4.54 0 0 1-1.433-.438 3.653 3.653 0 0 1-1.146-.886 3.98 3.98 0 0 1-.756-1.344 5.433 5.433 0 0 1-.269-1.772 4.917 4.917 0 0 1 .349-1.991c.21-.53.53-1.012.935-1.414.389-.379.854-.67 1.364-.856a4.75 4.75 0 0 1 1.643-.288 4.82 4.82 0 0 1 1.663.288c.51.185.975.477 1.364.856.403.402.719.884.926 1.414.25.634.375 1.31.368 1.991zm-6.58 0c-.006.384.044.766.148 1.135.097.32.248.62.449.886.194.237.439.427.716.558.312.144.653.212.996.199.343.014.685-.054.996-.2.282-.126.531-.317.726-.557.2-.267.352-.567.449-.886.104-.37.154-.751.149-1.135a4.208 4.208 0 0 0-.149-1.155 2.866 2.866 0 0 0-.449-.886 2.148 2.148 0 0 0-.726-.567 2.282 2.282 0 0 0-.996-.2 2.16 2.16 0 0 0-.996.21 2.112 2.112 0 0 0-.716.577c-.2.263-.352.56-.449.876a4.142 4.142 0 0 0-.149 1.145zM110.241 90.112a4.194 4.194 0 0 1-1.527-.254 2.9 2.9 0 0 1-1.054-.695 2.846 2.846 0 0 1-.618-1.066 4.32 4.32 0 0 1-.194-1.36v-5.235h1.924v5.108c-.006.297.033.594.116.88.066.215.175.415.319.587.132.147.298.258.483.323.199.069.408.102.618.098a1.52 1.52 0 0 0 1.122-.43c.323-.412.475-.935.425-1.459v-5.107h1.885v5.274c.004.465-.064.927-.203 1.37-.132.396-.346.76-.629 1.066-.305.31-.675.548-1.082.695a4.489 4.489 0 0 1-1.585.205zM115.463 90.118v-8.616h5.746v1.632h-3.831v1.691h3.399v1.592h-3.399v2.07h4.116v1.63h-6.031z",
    fill: "#42B0CE"
  }), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "paint0_linear_250_6791",
    x1: ".198",
    y1: "75.261",
    x2: "298.797",
    y2: "76.684",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#64C9C3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#50B3C8"
  })), ___EmotionJSX("linearGradient", {
    id: "paint1_linear_250_6791",
    x1: "126.663",
    y1: "132.333",
    x2: "239.523",
    y2: "132.333",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#FFFDFD"
  }), ___EmotionJSX("stop", {
    offset: ".73",
    stopColor: "#F9F9F9"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#E6E5E5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint2_linear_250_6791",
    x1: "166.293",
    y1: "110.368",
    x2: "175.779",
    y2: "110.368",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint3_linear_250_6791",
    x1: "180.939",
    y1: "110.368",
    x2: "190.425",
    y2: "110.368",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint4_linear_250_6791",
    x1: "195.585",
    y1: "110.368",
    x2: "205.071",
    y2: "110.368",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint5_linear_250_6791",
    x1: "210.231",
    y1: "110.368",
    x2: "220.569",
    y2: "110.368",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint6_linear_250_6791",
    x1: "225.739",
    y1: "110.368",
    x2: "235.216",
    y2: "110.368",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint7_linear_250_6791",
    x1: "166.293",
    y1: "132.329",
    x2: "175.779",
    y2: "132.329",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint8_linear_250_6791",
    x1: "180.939",
    y1: "132.329",
    x2: "190.425",
    y2: "132.329",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint9_linear_250_6791",
    x1: "195.585",
    y1: "132.329",
    x2: "205.071",
    y2: "132.329",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint10_linear_250_6791",
    x1: "210.231",
    y1: "132.329",
    x2: "220.569",
    y2: "132.329",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint11_linear_250_6791",
    x1: "225.739",
    y1: "132.329",
    x2: "235.216",
    y2: "132.329",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint12_linear_250_6791",
    x1: "194.724",
    y1: "162.482",
    x2: "209.37",
    y2: "162.482",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint13_linear_250_6791",
    x1: "179.216",
    y1: "162.482",
    x2: "193.862",
    y2: "162.482",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint14_linear_250_6791",
    x1: "137.001",
    y1: "110.799",
    x2: "146.478",
    y2: "110.799",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint15_linear_250_6791",
    x1: "151.647",
    y1: "110.799",
    x2: "161.124",
    y2: "110.799",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint16_linear_250_6791",
    x1: "137.001",
    y1: "132.339",
    x2: "146.478",
    y2: "132.339",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint17_linear_250_6791",
    x1: "151.647",
    y1: "132.339",
    x2: "161.124",
    y2: "132.339",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint18_linear_250_6791",
    x1: "54.294",
    y1: "121.128",
    x2: "132.703",
    y2: "121.128",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#fff"
  }), ___EmotionJSX("stop", {
    offset: ".73",
    stopColor: "#FAF6F6"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#E6E5E5"
  })), ___EmotionJSX("linearGradient", {
    id: "paint19_linear_250_6791",
    x1: "58.602",
    y1: "109.498",
    x2: "68.079",
    y2: "109.498",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint20_linear_250_6791",
    x1: "73.248",
    y1: "109.498",
    x2: "83.586",
    y2: "109.498",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint21_linear_250_6791",
    x1: "88.755",
    y1: "109.498",
    x2: "98.232",
    y2: "109.498",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint22_linear_250_6791",
    x1: "103.401",
    y1: "109.498",
    x2: "112.878",
    y2: "109.498",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint23_linear_250_6791",
    x1: "118.047",
    y1: "109.498",
    x2: "127.524",
    y2: "109.498",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint24_linear_250_6791",
    x1: "58.602",
    y1: "131.476",
    x2: "68.079",
    y2: "131.476",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint25_linear_250_6791",
    x1: "73.248",
    y1: "131.476",
    x2: "83.586",
    y2: "131.476",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint26_linear_250_6791",
    x1: "88.755",
    y1: "131.476",
    x2: "98.232",
    y2: "131.476",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint27_linear_250_6791",
    x1: "103.402",
    y1: "131.476",
    x2: "112.878",
    y2: "131.476",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint28_linear_250_6791",
    x1: "118.048",
    y1: "131.476",
    x2: "127.524",
    y2: "131.476",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  })), ___EmotionJSX("linearGradient", {
    id: "paint29_linear_250_6791",
    x1: "84.448",
    y1: "162.482",
    x2: "101.678",
    y2: "162.482",
    gradientUnits: "userSpaceOnUse"
  }, ___EmotionJSX("stop", {
    stopColor: "#D0E9F0"
  }), ___EmotionJSX("stop", {
    offset: ".25",
    stopColor: "#C9E6ED"
  }), ___EmotionJSX("stop", {
    offset: ".62",
    stopColor: "#B5DEE3"
  }), ___EmotionJSX("stop", {
    offset: "1",
    stopColor: "#9AD3D6"
  }))));
};

export default withIllustrationWrapper( /*#__PURE__*/forwardRef(IllustrationTlcAdvantage4));
//# sourceMappingURL=IllustrationTlcAdvantage4.js.map